import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HelperService } from '../../helpers/helper.service';
import { filterationParams } from '../../params/params';

@Injectable({
  providedIn: 'root'
})
export class TransportationPlansService {

  constructor(private http: HttpClient, private _helper: HelperService) { }

  getTransportationPlans(externalParams?: any) {
    let params = new filterationParams
    return this._helper.CallRequestList(`transportation/transportation-plans`, this._helper.CreateRequestParameters(externalParams ? externalParams : params.notPaginationParams))
  }

  getTransportationPlan(id: number) {
    return this._helper.CallRequestList(`transportation/transportation-plans/${id}`)
  }
}
